export enum Pages {
  CLIENT_SETTINGS = "Settings",
  AGENCIES = "Agencies",
  LOCATIONS = "Locations",
  TERMINALS = "Terminals",
}

export default Pages;
